import ConfirmationDialog from "@/components/common/ConfirmationDialog";
import { DialogOverlay } from "@/components/ui/dialog";
import { deleteNewsAlert } from "@/store/news-alerts/news-alerts-async.actions";
import { closeDeleteNewsAlertModal } from "@/store/news-alerts/news-alerts.actions";
import useNewsAlertsStore from "@/store/news-alerts/news-alerts.slice";

const DeleteNewsAlertModal = () => {
  const isDeleteNewsAlertModalOpen = useNewsAlertsStore(
    (state) => state.isDeleteNewsAlertModalOpen,
  );

  const isDeletingNewsAlert = useNewsAlertsStore(
    (state) => state.isDeletingNewsAlert,
  );

  const alertName = useNewsAlertsStore(
    (state) => state.createEditNewsAlert.alertName,
  );

  return (
    <DialogOverlay isOpen={isDeleteNewsAlertModalOpen}>
      <ConfirmationDialog
        title="Are you sure you want to delete this alert?"
        onCancelClick={closeDeleteNewsAlertModal}
        submitLoading={isDeletingNewsAlert}
        submitText="Yes, delete"
        submittingText="Deleting"
        submitVariant="secondaryDestructive"
        onSubmitClick={deleteNewsAlert}
      >
        <p className="text-sm leading-tight font-normal">
          {`This will permanently delete the "${alertName}" daily alert.`}
        </p>
      </ConfirmationDialog>
    </DialogOverlay>
  );
};

export default DeleteNewsAlertModal;
